module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"pageTitle":"Новая карта","save":"Сохранить","warning":"Для сохранения новой карты мы сделаем авторизацию платежа на <nobr>10 рублей</nobr>.<p> Деньги с вашей карты НЕ БУДУТ списаны.</p>"}}')
  delete Component.options._Ctor
}
